import React from 'react'

import Tick from 'components/common/Tick/Tick'

import {
    WrapperDiv,
    TickMarkWrapper,
    WhiteboardModesText,
    WhiteboardButton,
    WhiteboardIcon,
} from '../styles'

const ConnectToTablet = ({
    disabled,
    isConnectToTabletModalOpen,
    toggleConnectToTabletModalOpen,
}) => {
    const toggleModalState = () => toggleConnectToTabletModalOpen()

    return (
        <WrapperDiv onClick={toggleModalState}>
            <TickMarkWrapper>
                {isConnectToTabletModalOpen && <Tick />}
            </TickMarkWrapper>
            <WhiteboardButton
                disabled={disabled}
                clicked={isConnectToTabletModalOpen}
            >
                <WhiteboardIcon
                    clicked={isConnectToTabletModalOpen}
                    src="/assets/controls/latest/connect.svg"
                    alt="menu"
                />
            </WhiteboardButton>
            <WhiteboardModesText
                isClicked={isConnectToTabletModalOpen}
                isDisabled={disabled}
            >
                Open on tablet/ipad
            </WhiteboardModesText>
        </WrapperDiv>
    )
}

export default ConnectToTablet
